import React from "react";
import { number, func, bool } from "prop-types";
import Image from "pages/_components/Image";

export default function Pagination({ totalPages, pageNumber, action, showFirstAndLastButton, showText }) {
    Pagination.propTypes = {
        totalPages: number.isRequired,
        pageNumber: number.isRequired,
        action: func.isRequired,
        showFirstAndLastButton: bool.isRequired,
        showText: bool.isRequired,
    };

    return (
        <>
            {showFirstAndLastButton && (
                <div
                    onClick={() => pageNumber !== 1 && action(1)}
                    style={{
                        display: "inline",
                        marginRight: "3px",
                        cursor: pageNumber === 1 ? undefined : "pointer",
                    }}
                    key={0}
                    onKeyDown={() => pageNumber !== 1 && action(1)}
                    role="button"
                    tabIndex={0}>
                    <Image
                        className="svg-icon svg-caret"
                        src={`images/pagination-first${pageNumber === totalPages ? "-disabled" : ""}.svg`}
                    />
                </div>
            )}
            {pageNumber <= totalPages && (
                <div
                    onClick={() => pageNumber !== 1 && action(pageNumber - 1)}
                    style={{
                        display: "inline",
                        marginRight: "3px",
                        cursor: pageNumber === 1 ? undefined : "pointer",
                    }}
                    key={0}
                    onKeyDown={() => pageNumber !== 1 && action(pageNumber - 1)}
                    role="button"
                    tabIndex={0}>
                    <Image
                        className="svg-icon svg-caret"
                        src={`images/pagination-left${pageNumber === 1 ? "-disabled" : ""}.svg`}
                    />
                </div>
            )}
            {showText && <div>{`${pageNumber} de ${totalPages}`}</div>}
            {pageNumber <= totalPages && (
                <div
                    onClick={() => pageNumber !== totalPages && action(pageNumber + 1)}
                    style={{
                        display: "inline",
                        marginRight: "3px",
                        cursor: pageNumber === totalPages ? undefined : "pointer",
                    }}
                    key={totalPages + 1}
                    onKeyDown={() => pageNumber !== totalPages && action(pageNumber + 1)}
                    role="button"
                    tabIndex={0}>
                    <Image
                        className="svg-icon svg-caret"
                        src={`images/pagination-right${pageNumber === totalPages ? "-disabled" : ""}.svg`}
                    />
                </div>
            )}
            {showFirstAndLastButton && (
                <div
                    onClick={() => pageNumber !== totalPages && action(totalPages)}
                    style={{
                        display: "inline",
                        marginRight: "3px",
                        cursor: pageNumber === totalPages ? undefined : "pointer",
                    }}
                    key={totalPages + 1}
                    onKeyDown={() => pageNumber !== totalPages && action(totalPages)}
                    role="button"
                    tabIndex={0}>
                    <Image
                        className="svg-icon svg-caret"
                        src={`images/pagination-last${pageNumber === totalPages ? "-disabled" : ""}.svg`}
                        styles={{
                            fill: pageNumber === totalPages ? "#ddd" : "#0071ce",
                        }}
                    />
                </div>
            )}
        </>
    );
}
